import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { articles, categories, testimonials } from '@/mocks/articles';
import { useState, useEffect } from 'react';

const articleBodies: Record<string, string[]> = {
  'top-star-live-collapse-2026': [
    '昨晚，一条爆炸性消息在社交媒体上迅速发酵——某顶流男星在直播中不慎口误，疑似自曝恋情。事发直播间的在线观看人数在短短5分钟内从3万飙升至10万+，弹幕瞬间刷屏，服务器一度出现卡顿。',
    '据现场观众描述，该男星在与粉丝互动环节中，被问及"最近有什么开心的事"时，脱口而出"和女朋友一起看电影很开心"，话音未落脸色骤变，助理迅速上前切断直播画面。但为时已晚，整段视频已被大量网友录屏保存。',
    '事件爆发后，#顶流直播口误# 话题在微博迅速登顶热搜，阅读量半小时内突破2亿。该男星的超话社区瞬间沦陷，大批粉丝表达失望情绪，有站姐当场宣布脱粉并公开了大量此前拍摄的私密行程照片作为"回踩"证据。',
    '截至目前，该男星及其工作室均未对此事作出任何回应。业内人士分析认为，对于走流量路线的偶像型艺人而言，恋情曝光将直接影响其商业价值和粉丝基础，后续事态发展备受关注。',
  ],
  'wanghong-fake-products-scandal': [
    '近日，拥有千万粉丝的美妆博主"美美酱"被多名消费者联合举报，指控其通过直播带货渠道销售的某国际品牌护肤品为假货。消息一出，迅速引发广泛关注，相关维权群在24小时内涌入超过5000人。',
    '事件起因是一位消费者在使用该博主推荐的面霜后出现严重过敏反应，遂将产品送检。检测报告显示，该产品多项成分与正品不符，且含有未标注的致敏物质。该消费者将报告发布到社交平台后，迅速获得大量"同病相怜"的网友声援。',
    '更令人震惊的是，随后有多家国际美妆品牌方联合发布声明，明确表示从未授权该博主销售相关产品，并已委托律师发出联合律师函。涉事博主在舆论压力下紧急删除了所有相关推广视频，但并未正面回应假货指控。',
    '目前，市场监管部门已介入调查。法律专家指出，如果假货指控属实，该博主可能面临巨额赔偿乃至刑事责任。此次事件也再次引发了对直播带货行业监管的广泛讨论。',
  ],
};

const defaultArticleBody = [
  '近日，一则关于娱乐圈的最新爆料在网络上引发广泛关注和热议。据知情人士透露，该事件涉及多位圈内知名人士，相关细节正在被逐步曝光。本网记者第一时间展开调查，力求为读者还原事件全貌。',
  '事件爆发后，相关话题在各大社交平台迅速登上热搜榜单。大量网友涌入评论区发表自己的看法，舆论场呈现出多元化态势。有支持者认为应当理性看待，等待更多信息披露；也有批评者认为当事人应当尽快出面回应公众关切。',
  '截至目前，涉事各方均未对此事作出正式回应。但据可靠消息源透露，相关团队正在紧急商讨应对方案，预计近期将发布官方声明。业内人士分析认为，此次事件或将对涉事艺人的商业价值和公众形象产生深远影响。',
  '本网将持续关注此事后续进展，为读者带来最新、最全面的报道。在此也提醒广大网友理性吃瓜，不信谣不传谣，共同维护良好的网络环境。',
];

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const article = articles.find((a) => a.slug === slug);
  const [reviewIndex, setReviewIndex] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!article) {
    return (
      <>
        <Navbar />
        <div className="flex items-center justify-center h-96">
          <p className="text-foreground-400 text-lg">文章不存在</p>
        </div>
        <Footer />
      </>
    );
  }

  const category = categories.find((c) => c.slug === article.category);
  const bodyParagraphs = articleBodies[slug] || defaultArticleBody;
  const relatedArticles = articles.filter((a) => a.slug !== slug && a.category === article.category).slice(0, 3);
  const t = testimonials[reviewIndex % testimonials.length];

  const breadcrumbItems = [
    { name: category?.name || '分类', href: `/category/${article.category}` },
    { name: article.title.slice(0, 20) + '...' },
  ];

  const schemaData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Article',
        headline: article.title,
        description: article.excerpt,
        datePublished: article.date,
        author: { '@type': 'Person', name: article.author },
        publisher: { '@type': 'Organization', name: '51今日吃瓜网', url: 'https://www.51chigua.com' },
        image: article.imageUrl,
        url: `https://www.51chigua.com/article/${slug}`,
        mainEntityOfPage: `https://www.51chigua.com/article/${slug}`,
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.51chigua.com/' },
          { '@type': 'ListItem', position: 2, name: category?.name || '分类', item: `https://www.51chigua.com/category/${article.category}` },
          { '@type': 'ListItem', position: 3, name: article.title },
        ],
      },
    ],
  };

  return (
    <>
      <SEOHead
        title={article.title}
        description={article.excerpt}
        keywords={article.tags.join(',')}
        canonicalUrl={`/article/${slug}`}
        ogType="article"
        publishedTime={article.date}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />
      <Navbar />

      <main>
        <article>
          <section className="relative h-[420px] md:h-[560px] w-full overflow-hidden">
            <img
              src={article.imageUrl}
              alt={article.title}
              title={article.title}
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/75"></div>
            <div className="absolute inset-0 flex items-end">
              <div className="mx-auto w-full max-w-[1280px] px-6 md:px-10 pb-10 md:pb-14">
                <div className="flex flex-col lg:flex-row items-start lg:items-end gap-6 lg:gap-16">
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-4">
                      <span className="px-3 py-1 bg-accent-500 text-white text-xs font-bold rounded-full whitespace-nowrap">全网独家首发</span>
                    </div>
                    <h1 className="font-heading text-2xl md:text-3xl lg:text-4xl font-black text-white leading-tight max-w-3xl">
                      {article.title}
                    </h1>
                  </div>
                  <div className="lg:w-80 flex-shrink-0">
                    <p className="text-white/60 text-sm leading-relaxed">{article.excerpt}</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="bg-background-100 py-10 md:py-14">
            <div className="mx-auto max-w-[1280px] px-6 md:px-10">
              <Breadcrumb items={breadcrumbItems} />

              <div className="mt-8 flex flex-col lg:flex-row gap-10 lg:gap-16">
                <div className="flex-1 max-w-3xl">
                  <div className="flex items-center gap-3 mb-8 pb-6 border-b border-background-200/70">
                    <div className="w-10 h-10 rounded-full overflow-hidden">
                      <img src={article.authorAvatar} alt={article.author} className="w-full h-full object-cover" />
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-foreground-900">{article.author}</p>
                      <p className="text-xs text-foreground-400">{article.date} 发布</p>
                    </div>
                    <div className="ml-auto flex items-center gap-3 text-xs text-foreground-400">
                      <span className="flex items-center gap-1 whitespace-nowrap">
                        <i className="ri-eye-line"></i>
                        {article.views >= 10000 ? `${(article.views / 10000).toFixed(0)}万` : article.views} 阅读
                      </span>
                      <span className="flex items-center gap-1 whitespace-nowrap">
                        <i className="ri-chat-3-line"></i>
                        {article.comments >= 10000 ? `${(article.comments / 10000).toFixed(1)}万` : article.comments} 评论
                      </span>
                    </div>
                  </div>

                  <div>
                    {bodyParagraphs.map((paragraph, index) => (
                      <p key={index} className="text-foreground-700 text-base leading-relaxed mb-6">
                        {paragraph}
                      </p>
                    ))}
                  </div>

                  <div className="mt-8 pt-6 border-t border-background-200/70">
                    <div className="flex flex-wrap gap-2">
                      {article.tags.map((tag) => (
                        <span key={tag} className="px-3 py-1.5 bg-secondary-100 text-secondary-800 text-xs font-medium rounded-full whitespace-nowrap">
                          #{tag}
                        </span>
                      ))}
                    </div>
                    <div className="mt-6 flex items-center gap-4">
                      <span className="text-sm text-foreground-500">分享到：</span>
                      <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700 hover:bg-secondary-200 transition-colors cursor-pointer">
                        <i className="ri-weibo-line"></i>
                      </a>
                      <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700 hover:bg-secondary-200 transition-colors cursor-pointer">
                        <i className="ri-wechat-line"></i>
                      </a>
                      <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700 hover:bg-secondary-200 transition-colors cursor-pointer">
                        <i className="ri-twitter-x-line"></i>
                      </a>
                    </div>
                  </div>
                </div>

                <aside className="lg:w-80 flex-shrink-0">
                  <div className="sticky top-24">
                    <h3 className="font-heading text-lg font-bold text-foreground-900 mb-4">相关推荐</h3>
                    <div className="space-y-3">
                      {relatedArticles.map((ra) => (
                        <Link key={ra.slug} to={`/article/${ra.slug}`} className="flex gap-3 group cursor-pointer p-2 rounded-lg hover:bg-background-200/50 transition-colors">
                          <div className="w-20 h-20 rounded-lg overflow-hidden flex-shrink-0">
                            <img
                              src={ra.thumbUrl}
                              alt={ra.title}
                              className="w-full h-full object-cover object-top"
                            />
                          </div>
                          <div className="flex-1 min-w-0">
                            <h4 className="text-sm font-medium text-foreground-800 line-clamp-2 group-hover:text-primary-600 transition-colors leading-snug">
                              {ra.title}
                            </h4>
                            <p className="text-xs text-foreground-400 mt-1">{ra.date}</p>
                          </div>
                        </Link>
                      ))}
                    </div>
                  </div>
                </aside>
              </div>
            </div>
          </section>
        </article>

        <section className="py-14 md:py-20 bg-background-50">
          <div className="mx-auto max-w-[1280px] px-6 md:px-10">
            <div className="max-w-2xl mx-auto text-center mb-10">
              <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900">
                （精选神评）
              </h2>
            </div>

            <div className="max-w-2xl mx-auto relative">
              <div className="flex items-start gap-6">
                <div className="flex-shrink-0 mt-1">
                  <div className="px-4 py-2 bg-foreground-900 text-accent-500 rounded-full text-sm font-bold flex items-center gap-1.5 whitespace-nowrap">
                    <i className="ri-star-fill text-accent-500 text-xs"></i>
                    {t.rating}
                  </div>
                </div>
                <div className="flex-1">
                  <blockquote className="font-heading text-lg md:text-xl text-foreground-700 leading-relaxed italic">
                    &ldquo;{t.comment}&rdquo;
                  </blockquote>
                  <div className="mt-6 flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full overflow-hidden">
                      <img src={t.avatar} alt={t.username} className="w-full h-full object-cover" />
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-foreground-900">{t.username}</p>
                      <p className="text-xs text-foreground-400">{t.platform}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="absolute bottom-0 right-0 flex items-center gap-2">
                <button
                  onClick={() => setReviewIndex((c) => (c === 0 ? testimonials.length - 1 : c - 1))}
                  className="w-10 h-10 flex items-center justify-center rounded-lg border border-foreground-300 text-foreground-600 hover:bg-background-200 transition-colors cursor-pointer"
                  aria-label="上一条评论"
                >
                  <i className="ri-arrow-left-s-line text-lg"></i>
                </button>
                <button
                  onClick={() => setReviewIndex((c) => (c === testimonials.length - 1 ? 0 : c + 1))}
                  className="w-10 h-10 flex items-center justify-center rounded-lg bg-foreground-900 text-white hover:bg-foreground-800 transition-colors cursor-pointer"
                  aria-label="下一条评论"
                >
                  <i className="ri-arrow-right-s-line text-lg"></i>
                </button>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}